import { render, staticRenderFns } from "./ThreatsFakewallThreat.vue?vue&type=template&id=8e96fb2e"
import script from "./ThreatsFakewallThreat.vue?vue&type=script&lang=js"
export * from "./ThreatsFakewallThreat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports